import { message } from "antd";
import axios from "axios";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";
 
const url = process.env.REACT_APP_API_BASE_URL;

export const handleLogout = async () => {
  toast.error("Session has expired. Log in to continue");
  await localStorage.clear();
  window.location = await "./login"; 
}; 
const axiosInstance = axios.create({
  baseURL: url,
  headers: {
    "Content-Type": "application/json",
  },
});

 
axiosInstance.interceptors.response.use(
  (response) => { 
    return response;
  },
  (error) => {
    const statusCode = error.response ? error.response.status : null;
    if (statusCode == 403) {
      // handleLogout();
    }

    if (statusCode == 401) {
      handleLogout();
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
